module.exports = __webpack_public_path__ + "static/img/EN.d720434.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/pc/EN.png
// module id = wVni
// module chunks = 1